import * as $ from 'jquery';

import 'summernote/dist/summernote-bs4.css'
import 'summernote';

export default (
    function()
    {
        $('textarea.wysiwyg').summernote({
            minHeight: 300
        });
    }($)
);